import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class VehicleRegisterService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }

  getMaxId() :Observable <any[]>{
    return this.http.get<any[]>(`${this.env.apiUrl}/vehicle-register/getMaxId`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/vehicle-register`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    addVehicleRegister(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/vehicle-register`,  data)
        .pipe(catchError(this.handleError));
       
    }


    updateVehicleRegister(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/vehicle-register`, data)
        .pipe(catchError(this.handleError));
       
    }

    deleteVehicleRegister(id: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/vehicle-register/${id}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }



}

